export default {
  path: '/siteFacilities',
  name: 'siteFacilities',
  redirect: '/siteFacilities/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'list',
      component: () => import('@/views/siteFacilities'),
      meta: { requiresAuth: true }
    },
    {
      path: 'auxiliaryFacility',
      component: () => import('@/views/siteFacilities/auxiliaryFacility'),
      meta: { requiresAuth: true }
    },
    {
      path: 'auxiliaryFacilityAdmin',
      component: () => import('@/views/siteFacilities/auxiliaryFacilityAdmin'),
      meta: { requiresAuth: true }
    },
  ]
}
